import React from 'react';
import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import style from './circular.module.scss';
import cx from 'classnames';

export default function CircularLoader(props: CircularProgressProps) {
  return (
    <div className={cx(style.container, props.className)}>
      <CircularProgress size={props.size || 24} />
    </div>
  );
}
